import { useTenantData } from "contexts/tenant";

export const useDeployProcess = () => {
  const tenantData = useTenantData();
  return tenantData.deploy_process;
};
